import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {articleListBoxTitle, ArticleListBoxWide} from "../../../article/components/article_list/ArticleListBoxWide";

export const PricesArticlesList = () => {
    const articles = useSelector((state: IRPStore) => state.report.price.articles);

    return (
        <Container className={containerStyle}>
            <Text variant="headline_2" align="center" className={headingStyle}>
                Raporty i analizy cenowe
            </Text>

            <div className={articlesWrapper}>
                {articles.map((article) => (
                    <ArticleListBoxWide
                        article={article}
                        key={article.id}
                        articleTitle={
                            <Text as="h3" variant="headline_4" className={articleListBoxTitle}>
                                {article.header}
                            </Text>
                        }
                        className={articleItem}
                    />
                ))}

                <Link href={rpAppLink.article.category({categorySlug: "raporty"})} target="_blank" size="inherit" className={linkStyle}>
                    <Button variant="filled_primary" type="button">
                        zobacz więcej
                    </Button>
                </Link>
            </div>
        </Container>
    );
};

const articlesWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2
});

const containerStyle = css({
    mb: 8
});

const headingStyle = css({
    mb: 4
});

const articleItem = css({
    width: "100%",
    flexBasis: "100%"
});

const linkStyle = css({
    mt: 4
});
import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {articleListBoxTitle, ArticleListBoxWide} from "../../../article/components/article_list/ArticleListBoxWide";

export const PricesArticlesList = () => {
    const articles = useSelector((state: IRPStore) => state.report.price.articles);

    return (
        <Container className={containerStyle}>
            <Text variant="headline_2" align="center" className={headingStyle}>
                Raporty i analizy cenowe
            </Text>

            <div className={articlesWrapper}>
                {articles.map((article) => (
                    <ArticleListBoxWide
                        article={article}
                        key={article.id}
                        articleTitle={
                            <Text as="h3" variant="headline_4" className={articleListBoxTitle}>
                                {article.header}
                            </Text>
                        }
                        className={articleItem}
                    />
                ))}

                <Link href={rpAppLink.article.category({categorySlug: "raporty"})} target="_blank" size="inherit" className={linkStyle}>
                    <Button variant="filled_primary" type="button">
                        zobacz więcej
                    </Button>
                </Link>
            </div>
        </Container>
    );
};

const articlesWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2
});

const containerStyle = css({
    mb: 8
});

const headingStyle = css({
    mb: 4
});

const articleItem = css({
    width: "100%",
    flexBasis: "100%"
});

const linkStyle = css({
    mt: 4
});
